import { useState } from 'react';
import { LanguageContext } from '../../contexts/languageContext.tsx';
import { Bio } from '../bio/bio.tsx';
import { Contacts } from '../contacts/contacts.tsx';
import { Discography } from '../discography/discography.tsx';
import { Gigs } from '../gigs/gigs.tsx';
import { Header } from '../header/header.tsx';
import { Media } from '../media/media.tsx';
import { Player } from '../player/player.tsx';
import { Social } from '../social/social.tsx';
import './container.css';
import { Assets } from '../assets/assets.tsx';

function Container() {
    const [lang, setLang] = useState("en")

    const handleLanguageClick :(l:string) => void = (lang: string) => {
        setLang(lang)
    } 

    return (
        <LanguageContext value={lang}>
            <div id='container-bg'>
                <div>
                    <Header onClick={handleLanguageClick}/>
                    <div id='container'>
                        <Bio />
                        <Player />
                        <Media />
                        <Discography />
                        <Social />
                        <Assets />
                        <Contacts />
                    </div>
                </div>
        </div>
        </LanguageContext>
        
    )
}

export { Container };